import { useGetCompanyQuery } from 'app/api_v2/agency/queries';
import InfoMessage from 'app/ui_v2/components/info-message/InfoMessage';

import { Box } from '@mui/material';

import { canViewerEdit } from '../../helpers';
import { isProfileCanBePublished } from '../../publish-profile/helpers';
import AgencyProfileProgressList from './AgencyProfileProgressList';

export interface AgencyProfileProgressInfoProps {
  companyId: string;
}

export default function AgencyProfileProgressInfo(props: AgencyProfileProgressInfoProps) {
  const { companyId } = props;

  const { isSuccess, data } = useGetCompanyQuery(companyId);
  const isEditable = canViewerEdit(data);

  if (!data) {
    return null;
  }

  const title = isProfileCanBePublished(data)
    ? 'Your agency profile can is ready to publish now'
    : 'Complete these steps to publish your agency profile';

  return (
    <>
      {isSuccess && isEditable && data.state === 'draft' && (
        <Box py={2}>
          <InfoMessage
            type="superdark"
            notClosable={true}
            isSlim={true}
            title={title}
            content={<AgencyProfileProgressList companyData={data} />}
          />
        </Box>
      )}
    </>
  );
}
